///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransparentButtonDirective } from './transparent-button.directive';
import { RedButtonDirective } from './red-button.directive';
import { GreenButtonDirective } from './green-button.directive';
import { CloseButtonDirective } from './close-button.directive';
import { ActionIconButtonDirective } from './action-icon-button.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [TransparentButtonDirective, RedButtonDirective, GreenButtonDirective, CloseButtonDirective, ActionIconButtonDirective],
    exports: [TransparentButtonDirective, RedButtonDirective, GreenButtonDirective, CloseButtonDirective, ActionIconButtonDirective]
})
export class ButtonsDirectivesModule {}
